import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { getLatestUpdatedAt } from '../../helper/reducer.helper';
import { TextTemplateEntity } from '../../entities/text-template.entity';
import { TextTemplateActionTypes } from '../actions/text-template.actions';


export const TEXT_TEMPLATE_KEY = 'textTemplate';

export interface TextTemplateState extends EntityState<TextTemplateEntity> {
    fetched: boolean;
    latestUpdatedAt: Date;
}

const adapter = createEntityAdapter<TextTemplateEntity>({
    selectId: (Entity) => Entity.Id,
});

const initialState = adapter.getInitialState({
    fetched: false,
    latestUpdatedAt: null,
});

export const textTemplateReducer = createReducer(
    initialState,
    on(TextTemplateActionTypes.UpdateAll, (state, { Payload, updateLatestUpdatedAt }) =>
        adapter.setAll(Payload, { ...state }/*, fetched: true, latestUpdatedAt: updateLatestUpdatedAt ? getLatestUpdatedAt(Payload, state.latestUpdatedAt) : state.latestUpdatedAt }*/),
    ),
    on(TextTemplateActionTypes.UpdateOne, (state, { Payload }) => adapter.setOne(Payload, state)),
    on(TextTemplateActionTypes.CreateSuccess, (state, { Payload }) => adapter.addOne(Payload, state)),
    on(TextTemplateActionTypes.RemoveOne, (state, { Payload }) => adapter.removeOne(Payload, state)),
    on(TextTemplateActionTypes.UpdateMany, (state, { Payload, updateLatestUpdatedAt }) =>
        adapter.setMany(Payload, {
            ...state,
            latestUpdatedAt: updateLatestUpdatedAt ? getLatestUpdatedAt(Payload, state.latestUpdatedAt) : state.latestUpdatedAt,
        }),
    ),
);

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllTextTemplate = selectAll;
export const selectTextTemplateEntities = selectEntities;

export const selectTextTemplateFetched = (state: TextTemplateState) => state.fetched;
export const selectTextTemplateLatestUpdatedAt = (state: TextTemplateState) => state.latestUpdatedAt;
